'use client';

import { usePathname, useRouter } from '@/i18n/routing';

export default function GetPriceBreakUpBtn({ children, className }) {
  const router = useRouter();
  let pathName = usePathname();

  return (
    <div className="text-center justify-center flex w-auto items-center hover:cursor-pointer">
      <button
        className={`${className} hover:cursor-pointer`}
        onClick={() => router.push(`${pathName}/buynow`)}
      >
        {children}
      </button>
      {/* <LeadForm isOpen={isOpen} setIsOpen={setIsOpen} formType={formName} /> */}
    </div>
  );
}
